import React, { forwardRef } from "react";
import { useFormContext } from "react-hook-form";

const TextInput = forwardRef(
  ({ name, label, disabled, ...inputProps }, ref) => {
    const {
      register,
      formState: { errors },
    } = useFormContext();

    return (
      <div className="sm:col-span-3">
        {label && (
          <label
            htmlFor={name}
            className={`block text-sm font-medium mb-1 ${
              disabled ? "text-gray-400 dark:text-gray-500" : "text-gray-600 dark:text-gray-300"
            }`}
          >
            {label}
          </label>
        )}
        <div>
          <input
            {...register(name)}
            {...inputProps}
            id={name}
            type="text"
            autoComplete="off"
            disabled={disabled}
            className={`block justify-between gap-x-1.5 w-full rounded-md px-3 py-2.5 items-center text-sm leading-none font-normal border-0 transition-colors duration-150 ${
              disabled
                ? "text-gray-400 dark:text-gray-500 bg-gray-100 dark:bg-gray-800 cursor-not-allowed"
                : "text-gray-500 dark:text-gray-200 hover:text-gray-800 dark:hover:text-gray-100 hover:bg-gray-100 dark:hover:bg-white/[0.06] bg-gray-50 dark:bg-gray-800"
            }`}
          />
          {errors[name] && (
            <p className="mt-2 text-sm text-danger">{errors[name]?.message}</p>
          )}
        </div>
      </div>
    );
  }
);

export { TextInput };
